export enum FileType {
  Directory = 'DIRECTORY',
  Symlink = 'SYMLINK',
}
